import React, {useEffect, useState} from 'react';
import {createTheme, makeStyles, MuiThemeProvider} from '@material-ui/core/styles';
import {Box, Button, Divider, Grid, Icon, Paper, TextField, Typography} from '@material-ui/core'
import SyncOffice from './syncOffice.png'
import {ApiPostData} from "@project/shared/src/services/ApiPostData";
import {BaseLink, BaseServer, BaseServerWebsite, BaseURL} from "@project/shared/src/services/postData";
import MaterialUiButtons from "@project/shared/src/components/button/materialUiButton";
import {toast} from "react-toastify";
import MaterialUiInputHooks from "@project/shared/src/components/material-ui-input-hooks";
import MaterialUiCheckbox from "@project/shared/src/components/materialUiCheckbox/materialUiCheckbox";
import {
  redColor,
  settingsMain,
  settingsPrimary,
  settingsPrimaryShadow,
  settingsSecondary
} from "@project/shared/src/colorCode/colorCode";

const theme = createTheme({
  overrides: {
    MuiOutlinedInput: {
      root: {
        "&focused notchedOutline": {
          border: "1px solid #66afe9 !important",
          outline: 'none',
          boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6) !important"
        },
      },
    },
  },
  typography: {
    fontFamily: [
      '"Montserrat", sans-serif' + '!important'
    ].join(','),
  },
});


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    textAlign: 'left',
  },

  paper: {
    padding: theme.spacing(4),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },

  customTextField: props => ({
    "& >label": {},
    "& .MuiSelect-icon": {
      position: "inherit",
      cursor: "pointer"
    },
    "&>div>fieldset>legend": {
      background: 'white'
    },
    "& .MuiIconButton-root:focus": {
      outline: "none"
    },
    "& >div>svg": {
      right: props.iconData !== undefined ?
        props.iconData.length === 2 ? 62 : props.iconData.length === 1 ? 41 : props.iconData.length === 3 ? 84 : ""
        : "",
    },
  }),
  errorStyle: {
    color: 'red',
    float: 'left',
    padding: '0 5px',
    transform: 'translate(-5px, 6px) scale(0.75)',
    background: 'white',
    height: 'max-content',
    marginTop: '-19px',
  },

}));
const fields = {
  email: {value: '', valid: true, errorLabel: '', error: ''},
  password: {value: '', valid: false, errorLabel: 'Enter Valid OTP', error: ''},
  rePassword: {value: '', valid: false, errorLabel: 'Enter Valid OTP', error: ''},
  checkedStatus: {value: false}
};
const Setpsw = (props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [activationField, setActivationField] = useState({...fields});
  const [email, setEmail] = useState();
  const [formValid, setFormValid] = useState(false);
  const [viewStatus, setViewStatus] = useState({password: false, rePassword: false});
  const [infoStatus, setInfoStatus] = useState(false);
  const [viewPage, setViewPage] = useState(false);

  const [propsDrawer, setPropsDrawer] = useState({
    background: settingsPrimary,
    boxShadow: settingsPrimaryShadow,
    secondaryBg: settingsSecondary,
    mainBg: settingsMain,
  });


  useEffect(() => {
    getDatabase();

    return () => {
    }
  }, [props]);


  const handleClickOpen = () => {
    let data = {};
    data['licence'] = props.licence;
    data['otp'] = activationField['otp'].value;
    data['email'] = email;
    ApiPostData('api/websiteApi.php', 'checkOtpValid', data).then(result => {
      if (!result['status']) {
        setOpen(true);
      } else if (result['status']) {
        window.location.href = `{$BaseURL}` + "setPsw?user=" + result['user'] + "&active=" + result['code'] + "&lic=" + props.licence;
      }
    });

  };


  const changeInField = (e, fieldname) => {
    let updateForm = {...activationField};
    let updateFormField = updateForm[fieldname];
    if (fieldname === 'checkedStatus') {
      updateFormField.value = e.target.checked;
    } else {
      updateFormField.value = e.target.value;
    }

    setActivationField(updateForm);
  }


  const getDatabase = () => {
    let data = {};
    data['licenceId'] = props.licence;
    let code = props.active;
    ApiPostData('api/websiteApi.php', 'getDBDetails', data).then(result => {
      if (result.length > 0) {
        let user = {};
        user['db'] = result[0]['database_name'];
        user['userId'] = props.user;
        let email = '';
        let validation_code = '';
        let status = '';
        ApiPostData('api/websiteApi.php', 'getUserDetails', user).then(resultUser => {
          if (resultUser.length > 0) {
            email = resultUser[0]['username'];
            validation_code = resultUser[0]['validation_code'];
            status = resultUser[0]['status'];
            activationField['email'].value = email;
            setActivationField({...activationField});
          }
          if (validation_code == code && status == 0) {
            setViewPage(true);
          } else if (status == 1 && (validation_code == "" || validation_code == "0" || validation_code == "Null")) {
            toast.error("Account is already activiated, kindly login");
            setTimeout(() => {
              window.location = `${BaseURL}`;
            }, 4000);
          } else {
            toast.error("Activiation link Expired");
            setTimeout(() => {
              window.location = `${BaseURL}`;
            }, 4000);
          }
        });
      }
    });
  }


  function resetPwd() {

    var regex = /^((?=.*\d)(?=.*[a-z])|(?=.*\d)(?=.*[A-Z])).{6,25}$/;
    var regex1 = /^\S*$/;
    var new_pass = activationField['password'].value;
    var re_enter_pass = activationField['rePassword'].value;
    var prop_check = activationField["checkedStatus"].value;
    if (new_pass == "") {
      toast.error('Enter the Password');
      return false;
    }
    if (!regex.test(new_pass) || !regex1.test(new_pass)) {
      toast.error('Password is not strong');
      return false;
    } else if (re_enter_pass == "") {
      toast.error("Enter password");
      return false;
    } else if (new_pass != re_enter_pass) {
      toast.error("password doesn't match");
      return false;
    } else if (!prop_check) {
      toast.error("Accept the Term and Conditions");
      return false;
    }

    var resetPwdDetalis = {};
    resetPwdDetalis['user_id'] = props.user;
    resetPwdDetalis['validation_code'] = props.active;
    resetPwdDetalis['password'] = activationField['password'].value;
    resetPwdDetalis['email'] = activationField['email'].value;
    resetPwdDetalis['licenceId'] = props.licence;
    let data = {};
    data['json_detail'] = resetPwdDetalis;

    ApiPostData('api/websiteApi.php', 'resetpwd', data).then(result => {
      if (result) {
        toast.success('Account activiated Successful');

        setTimeout(() => {
          window.location = `${BaseServer}login`;
        }, 4000);

      } else {
        toast.error('Activation Link Expired');
        setTimeout(() => {
          window.location = `${BaseServer}login`;
        }, 4000);
      }
    });
  }

  function showPassword(field) {
    let updateForm = {...viewStatus};
    updateForm[field] = !updateForm[field];
    setViewStatus({...updateForm})

  }

  function changeInfo() {
    setViewStatus(!infoStatus)
  }


  return (
    <MuiThemeProvider theme={theme}>
      <Box className={classes.root} pt={2} px={3}>

        <img src={SyncOffice} alt='SyncOffice' style={{height: 100}}/>

        <Paper className={classes.paper}>
          <Typography variant="h5" color='textPrimary'>
            Reset Password
          </Typography>

          <form className={classes.form} noValidate autoComplete="off">
            <Box pt={2}>
              <TextField
                label='Email'
                variant='outlined'
                size='small'
                required
                fullWidth
                className={classes.customTextField}
                value={activationField['email']['value']}
                disabled
              />
            </Box>

            <Box pt={2}>
              <MaterialUiInputHooks
                label="Password"
                inputType="input"
                value={activationField['password'].value}
                type={viewStatus['password'] ? 'text' : 'password'}
                change={(event) => changeInField(event, 'password')}
                required={true}
                adornment={true}
                error={activationField['password'].error}
                propsDrawer={propsDrawer}
                iconData={[
                  {
                    tooltip: viewStatus['password'] ? 'View Password' : 'Hide Password',
                    iconName: viewStatus['password'] ? 'visibility' : 'visibility_off',
                    action: () => showPassword('password')
                  }
                ]}
              />
            </Box>


            <Box pt={2}>
              <MaterialUiInputHooks
                label="Confirm Password"
                inputType="input"
                value={activationField['rePassword'].value}
                type={viewStatus['rePassword'] ? 'text' : 'password'}
                change={(event) => changeInField(event, 'rePassword')}
                required={true}
                adornment={true}
                error={activationField['rePassword'].error}
                propsDrawer={propsDrawer}
                iconData={[
                  {
                    tooltip: viewStatus['rePassword'] ? 'View Password' : 'Hide Password',
                    iconName: viewStatus['rePassword'] ? 'visibility' : 'visibility_off',
                    action: () => showPassword('rePassword')
                  }
                ]}
              />
            </Box>

            <Box pt={2} style={{lineHeight: 0}}>
              <Typography variant="caption" style={{lineHeight: 1}}>
                Password must contain at least 6 characters including at least 1 Numeric value,
                at least 1 Alphabet value,Not have any space in-between
              </Typography>
            </Box>

            <Box pt={2}>
              <MaterialUiCheckbox
                checkStatus={activationField['checkedStatus'].value}
                checkClick={(event) => changeInField(event, 'checkedStatus')}
                cardStyle={propsDrawer}
                label={<span> I accept <a
                  href={`${BaseServer}termsandconditions.php`} target="_blank">Terms and Conditions</a></span>}
              />
               </Box>
          </form>

          <Box display="flex" mt={2} justifyContent="flex-end">
            <Box mr={2}>
              <a href={`${BaseLink}${BaseServerWebsite}freetrial`} style={{textDecoration: 'none'}}>
                <MaterialUiButtons
                  color={redColor}
                  btnTitle="Cancel"
                  iconName="close"
                  btnSize="small"
                />
              </a>
            </Box>
            <Box>
              <MaterialUiButtons
                btnClick={() => resetPwd()}
                color="#1b5e20"
                btnTitle="Submit"
                iconName='save'
                btnSize="small"
              />
            </Box>
          </Box>


        </Paper>

      </Box>
    </MuiThemeProvider>
  );
};

export default Setpsw;
